import React from 'react';

import Modal from 'components/shared/Modal';

import CustomPrivacyPolicy from '../LocalLegalInfo/CustomPrivacyPolicy';
import CustomTermsOfService from '../LocalLegalInfo/CustomTermsOfService';

const PoliciesModal = ({ isOpen, toClose, type = 'privacy-policy' }) => {
  return (
    <Modal isOpen={isOpen} toClose={toClose}>
      {type === 'privacy-policy' && <CustomPrivacyPolicy />}
      {type === 'terms-of-service' && <CustomTermsOfService />}
    </Modal>
  );
};

export default PoliciesModal;
